import { motion, useReducedMotion } from "framer-motion";
import { LEADS } from "../constants/testIds";
import { useAppData } from "../contexts/AppDataContext";
import { fadeUp } from "../lib/motion";
import { LeadTabsBoard } from "../components/leads/LeadTabsBoard";

// Owner Cockpit's org-wide Lead pipeline — same `LeadTabsBoard` as the Front Desk's `/desk/leads`
// (see that file's own comment), just scoped by the shell's own global branch switcher
// (`selectedBranchId`, defaults to "all") instead of a single fixed branch, since a Super Admin
// oversees every branch's pipeline at once.
export default function Leads() {
  const { branches, selectedBranchId } = useAppData();
  const reducedMotion = useReducedMotion();

  return (
    <div data-testid={LEADS.page} className="space-y-5">
      <motion.div {...fadeUp(reducedMotion)}>
        <h1 className="text-2xl font-bold" style={{ color: "var(--scarlet-text)" }}>Lead Pipeline</h1>
        <p className="text-sm mt-0.5" style={{ color: "var(--scarlet-text-secondary)" }}>Track enquiries across every branch, from first contact through to conversion.</p>
      </motion.div>

      <LeadTabsBoard branchId={selectedBranchId} branches={branches} memberDetailPath={(id) => `/app/members/${id}`} />
    </div>
  );
}
